/**
 * Returns true if the current time is in the interval of 15 minutes before the meeting to the end of the meeting.
 * @param {Date} meetingStart the start time of the meeting. Includes the start date and start time.
 * @param {Date} meetingEnd the end time of the meeting. Includes the end date and end time.
 * @param {Boolean} isCheckedIn true if the meeting has been checked in to, false otherwise.
 */
export const isCheckIn = ({isCheckedIn, meetingStart, meetingEnd}) => {
  const currentTime = Date.now()
  let startTime = meetingStart.getTime()
  let endTime = meetingEnd.getTime()

  // Adjust the start of the interval to be 15 minutes before the meeting start time
  let startInterval = startTime - 15 * 60 * 1000

  return !isCheckedIn && currentTime >= startInterval && currentTime <= endTime
}

/**
 * Returns true if the meeting start time is today and the meeting has been checked in to.
 * @param {Boolean} isCheckedIn true when the meeting has been checked in to.
 * @param {Date} meetingStart The start time of the meeting.
 * @param {Date} meetingEnd The end time of the meeting
 */
export const isCheckOut = ({isCheckedIn, meetingStart, meetingEnd}) => {
  const currentTime = Date.now()
  let startTime = meetingStart.getTime()
  let endTime = meetingEnd.getTime()
  // Adjust the start of the interval to be 15 minutes before the meeting start time
  let startInterval = startTime - 15 * 60 * 1000

  return isCheckedIn && currentTime >= startInterval && currentTime <= endTime
}

const convertTimeToNumeric = time =>
  time.getHours() + (time.getMinutes() > 29 ? 0.5 : 0)


/**
 * Returns the smallest range for the room reservation interval
 * using the app parameters and the rm_arrange values
 */
export const getReservationStartEndTimes = ({reservationTimes, rmArrange}) => {
  const {start: reservationStart, end: reservationEnd} = reservationTimes
  const {dayStart, dayEnd, postBlock} = rmArrange

  // Handle the case where the room start and end times are not available.
  let roomStart = dayStart || new Date(1900, 0, 1, 0, 0)
  let roomEnd = dayEnd || new Date(1900, 0, 1, 23, 59)

  // Convert room times to numeric values
  let roomStartTime = convertTimeToNumeric(roomStart)
  let roomEndTime = convertTimeToNumeric(roomEnd)   // TODO: used to be -1 why?
  return {
    start: Math.max(roomStartTime, reservationStart),
    end: Math.min(roomEndTime, reservationEnd - 1),
    postBlock: Math.ceil(postBlock/30) / 2
  }
}
